module.exports = __webpack_public_path__ + "img/icon_input_instagram.c8a85b5.svg";